import React, { Fragment, } from "react"

//core components
import Table from '@material-ui/core/Table';
import TablePagination from '@material-ui/core/TablePagination';

import FrameListTableHead from "views/FramesManagement/FrameListTableHead"
import FrameListTableBody from "views/FramesManagement/FrameListTableBody"

// CSS
import { useJobsStyles } from "styles/jobs/jobsCss"
import { useJobsTableStyles } from "styles/jobs/jobsTableCss"

// OpticianUsers Table -> HEAD
export default function FrameListTable(props) {
  const {
    countFramesRows,
    handleClickDelete,
    handleClickOpen,
    handleFrameUpload,
    isFullTable,
    loading,
    onRequestSort,
    order,
    orderBy,
    page,
    rows,
    rowsPerPage,
    setOpenFrameList,
    setPage,
    setRowsPerPage,
  } = props

  const classes = useJobsStyles()
  const classesTable = useJobsTableStyles()


  // Click change page
  const handleChangePage = (event, newPage) => {
    setPage(newPage)
  }

  // Click rows per page
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(1)
  }

  return (
    <Fragment>
      <Table className={classes.table} aria-label="simple table">

        <FrameListTableHead
          isFullTable={isFullTable}
          classes={classes}
          order={order}
          orderBy={orderBy}
          onRequestSort={onRequestSort}
        />

        <FrameListTableBody
          isFullTable={isFullTable}
          rows={rows}
          classes={classesTable}
          order={order}
          orderBy={orderBy}
          page={page}
          rowsPerPage={rowsPerPage}
          setOpenFrameList={setOpenFrameList}
          handleFrameUpload={handleFrameUpload}
          loading={loading}
          handleClickOpen={handleClickOpen}
          handleClickDelete={handleClickDelete}
        />
      </Table>

      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={countFramesRows}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />

    </Fragment>

  );

}
